export default __webpack_public_path__ + "static/media/sleepRentDoTwitter-600x314.b57874c1.jpg";